var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3200",
    "data-name": "Rectangle 3200",
    width: 67.172,
    height: 68.388,
    fill: "#55b864"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1704",
    "data-name": "Group 1704",
    transform: "translate(-1425 -1262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    transform: "translate(1425 1262)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5952",
    "data-name": "Group 5952",
    transform: "translate(1445 1278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5951",
    "data-name": "Group 5951",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M4.183,216.486a3.638,3.638,0,0,1-2.86-2.906,5.508,5.508,0,0,1-.064-1c0-5.118-.041-10.236.017-15.353a18.459,18.459,0,0,0-.753-5.644A5.437,5.437,0,0,1,.265,189.3a3.4,3.4,0,0,1,2.795-2.861q6.3-1.665,12.6-3.359,5.077-1.357,10.152-2.72a3.48,3.48,0,0,1,4.631,2.655q.425,1.576.844,3.154c.251.946.04,1.328-.885,1.577q-9.989,2.684-19.978,5.365a.845.845,0,0,0-.44.253H30.955c1.188,0,1.393.2,1.394,1.4,0,5.763-.054,11.527.028,17.289.031,2.215-.695,3.742-2.863,4.434ZM3.223,201.7c-.014.246-.032.422-.032.6q0,5.174,0,10.347c0,1.373.574,1.936,1.956,1.937q11.693,0,23.386,0c1.35,0,1.9-.559,1.905-1.9q0-5.174,0-10.347c0-.211-.017-.423-.027-.631Zm14-6.446c-1.977,0-3.773-.012-5.569.017a.926.926,0,0,0-.616.369c-.654.9-1.272,1.818-1.9,2.734-.294.429-.578.863-.931,1.391,1.974,0,3.81,0,5.646-.008a.541.541,0,0,0,.386-.19c.976-1.391,1.936-2.792,2.984-4.313m8.243,0c-1.985,0-3.818-.007-5.652.013a.693.693,0,0,0-.463.287c-.918,1.306-1.819,2.624-2.72,3.942a.827.827,0,0,0-.054.269c1.837,0,3.631.008,5.425-.012a.767.767,0,0,0,.543-.274c.958-1.355,1.89-2.727,2.92-4.225M6.56,187.5c1.38,1.174,2.62,2.25,3.894,3.286a1.023,1.023,0,0,0,.783.113c1.226-.3,2.441-.652,3.659-.986.481-.132.961-.265,1.545-.426-1.361-1.161-2.622-2.244-3.9-3.313a.626.626,0,0,0-.474-.14c-1.8.464-3.59.951-5.512,1.466m7.992-2.13c1.084.926,2.118,1.7,3.02,2.61a2.143,2.143,0,0,0,2.526.583c1.37-.48,2.8-.791,4.32-1.207-1.388-1.184-2.68-2.293-3.985-3.386a.552.552,0,0,0-.431-.068c-1.773.468-3.543.951-5.45,1.468m15.874,9.88a3.213,3.213,0,0,1-.553,0,2.713,2.713,0,0,0-3.244,1.658,25.527,25.527,0,0,1-1.9,2.818h5.7Zm-27.173.021v4.491c.745,0,1.451.036,2.149-.019a1.119,1.119,0,0,0,.735-.4c.821-1.128,1.6-2.289,2.387-3.44.13-.189.248-.386.409-.636Zm26-9.215c-.259-.98-.476-1.885-.741-2.775A1.538,1.538,0,0,0,26.5,182.16c-1.161.29-2.313.616-3.467.932a3.353,3.353,0,0,0-.426.189c1.307,1.117,2.55,2.191,3.812,3.241a.787.787,0,0,0,.6.145c.731-.168,1.451-.388,2.244-.608M2.924,193.127l5.566-1.495c-1.245-1.062-2.393-2.039-3.54-3.018a1.515,1.515,0,0,0-2.04-.08,1.446,1.446,0,0,0-.74,1.638c.213.972.489,1.93.753,2.955",
    transform: "translate(-0.188 -148.099)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M199.214,279.17c-.2-.079-.405-.162-.61-.236a3.838,3.838,0,0,1-2.593-3.605q-.025-7.511,0-15.022a3.837,3.837,0,0,1,3.828-3.831q7.463-.041,14.926,0a3.855,3.855,0,0,1,3.88,3.861c.039,4.985.03,9.97,0,14.955A3.893,3.893,0,0,1,215.893,279c-.142.048-.277.116-.415.174Zm-1.319-11.385q0,3.571,0,7.141a2.092,2.092,0,0,0,2.348,2.339q7.094.007,14.188,0a2.06,2.06,0,0,0,2.3-2.307q.011-7.141,0-14.283a2.059,2.059,0,0,0-2.3-2.306q-7.094-.009-14.189,0a2.092,2.092,0,0,0-2.347,2.341q-.006,3.537,0,7.075",
    transform: "translate(-161.091 -210.782)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M246.82,0a1.468,1.468,0,0,1,.59,1.313c-.029,1.307-.006,2.615-.01,3.922,0,.865-.348,1.316-.973,1.3-.6-.017-.931-.467-.933-1.28,0-1.308.019-2.615-.01-3.922A1.33,1.33,0,0,1,246.153,0Z",
    transform: "translate(-201.764)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M201.029,80.465a2.688,2.688,0,0,1,.2,2.943.738.738,0,0,0,.054.536,2.5,2.5,0,0,1-2.16,3.7,1.012,1.012,0,0,0-.58.321,7.485,7.485,0,0,0-.571.819,3.146,3.146,0,0,1-2.641,1.441c-1.177.017-2.355.012-3.532,0a3.24,3.24,0,0,1-2.886-1.73,1.644,1.644,0,0,0-1.367-.935,2.4,2.4,0,0,1-1.82-3.44,1.141,1.141,0,0,0,0-1.049,2.529,2.529,0,0,1,.39-2.7c-.882-1.344-1.792-2.659-2.629-4.018a14.038,14.038,0,0,1-2.38-7.794A12.436,12.436,0,0,1,205.85,67.3a11.985,11.985,0,0,1-1.531,7.781c-1.014,1.822-2.17,3.564-3.289,5.386m-7.5-.852c1.711,0,3.421.01,5.132-.012a.918.918,0,0,0,.674-.263c1.166-1.784,2.377-3.546,3.415-5.4a9.649,9.649,0,0,0,1.1-6.967,10.128,10.128,0,0,0-7.673-8.124,9.9,9.9,0,0,0-10.631,3.364A9.636,9.636,0,0,0,184,73.166a58.154,58.154,0,0,0,3.786,6.183.918.918,0,0,0,.677.254c1.688.021,3.377.011,5.065.011m-.023,1.892c-1.777,0-3.554,0-5.331,0-.427,0-.781.083-.775.592.005.464.344.574.739.574q5.365,0,10.729,0c.407,0,.78-.072.768-.6s-.4-.561-.8-.56q-2.666,0-5.331,0m.053,3.057c-1.775,0-3.55,0-5.325,0-.4,0-.8.016-.817.54-.017.568.4.6.83.6q5.292,0,10.584,0c.427,0,.836-.031.81-.613-.025-.55-.436-.524-.823-.524h-5.259m-2.848,3.091c.847.965,5.05.912,5.59,0Z",
    transform: "translate(-148.846 -46.505)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M19.887,78.085c0,2.07.007,4.139,0,6.209a3.513,3.513,0,0,1-3.747,3.758q-6.2,0-12.394,0A3.523,3.523,0,0,1,.006,84.342q-.013-6.243,0-12.485a3.515,3.515,0,0,1,3.725-3.72q6.23-.016,12.461,0a3.489,3.489,0,0,1,3.693,3.738c.01,2.07,0,4.139,0,6.209m-1.9.013q0-3.036,0-6.071c0-1.384-.6-1.993-1.985-1.994q-6.06-.005-12.119,0c-1.354,0-1.965.6-1.968,1.946q-.012,6.1,0,12.21c0,1.353.611,1.958,1.955,1.959q6.06.007,12.119,0c1.395,0,2-.6,2-1.979q0-3.036,0-6.071",
    transform: "translate(0 -55.996)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M343.774,122.979c-.711,0-1.422.014-2.132,0a.966.966,0,0,1-1.058-.955.94.94,0,0,1,1.051-.957q2.2-.033,4.4,0a.974.974,0,0,1,1.067.953c0,.566-.433.95-1.127.962-.733.013-1.466,0-2.2,0",
    transform: "translate(-279.928 -99.489)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M313.884,40.7c-.237-.192-.6-.345-.695-.6a1.14,1.14,0,0,1,.063-.977c1.1-1.189,2.249-2.338,3.422-3.457a.845.845,0,0,1,1.258.085.854.854,0,0,1,.039,1.263c-1.107,1.155-2.249,2.277-3.394,3.393a2.4,2.4,0,0,1-.693.292",
    transform: "translate(-257.349 -29.112)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "M127.989,122.981c-.71,0-1.42.013-2.13,0a.95.95,0,0,1-1.057-.948.92.92,0,0,1,1.034-.965q2.2-.034,4.393,0a.951.951,0,0,1,1.066.943c.005.581-.412.959-1.109.972-.732.014-1.464,0-2.2,0",
    transform: "translate(-102.575 -99.49)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "M165.222,39.734c-.185.238-.341.618-.611.734a1.1,1.1,0,0,1-.969-.078c-1.186-1.1-2.329-2.255-3.448-3.426a.932.932,0,0,1,1.3-1.319c1.176,1.114,2.307,2.275,3.441,3.433a2.44,2.44,0,0,1,.289.655",
    transform: "translate(-131.469 -29.105)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    d: "M72.459,315.455c0-1.244-.008-2.488,0-3.732.009-1.081.692-1.475,1.633-.934q3.2,1.837,6.383,3.7c.97.567.96,1.351-.025,1.927q-3.156,1.845-6.328,3.662c-.972.558-1.656.16-1.664-.958-.008-1.222,0-2.443,0-3.665m1.914,2.262,3.93-2.284-3.93-2.26Z",
    transform: "translate(-59.552 -255.242)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "M233.851,286.936v-1.16c0-2-.008-4,0-6.007.006-1.115.708-1.516,1.676-.964q1.851,1.055,3.687,2.135c.678.4.874.892.585,1.41-.3.537-.876.628-1.561.236-.783-.448-1.562-.9-2.463-1.425,0,.378,0,.614,0,.851,0,2.67.015,5.34-.015,8.009a3.366,3.366,0,1,1-2.69-3.27c.235.051.469.111.778.185m-.006,3.114a1.436,1.436,0,0,0-1.424-1.456,1.471,1.471,0,0,0-1.481,1.414,1.455,1.455,0,0,0,1.471,1.482,1.426,1.426,0,0,0,1.434-1.44",
    transform: "translate(-188.244 -228.949)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    d: "M227.639,107.888c0-1.6-.005-3.2,0-4.8.005-1.2.695-1.6,1.734-1.005q4.181,2.41,8.351,4.838c1.007.587,1,1.383-.016,1.973q-4.143,2.41-8.294,4.8c-1.111.641-1.773.24-1.776-1.069,0-1.579,0-3.158,0-4.738m1.963,3.5,5.989-3.478L229.6,104.45Z",
    transform: "translate(-187.097 -83.674)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M36.976,99.854a5.239,5.239,0,1,1-5.244-5.266,5.27,5.27,0,0,1,5.244,5.266m-8.552-.031a3.327,3.327,0,1,0,3.305-3.3,3.312,3.312,0,0,0-3.305,3.3",
    transform: "translate(-21.779 -77.743)",
    fill: "#55b864"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.4bd03dd73184dee1747fdeab3a845276.svg";
export { ForwardRef as ReactComponent };